exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nb-text[data-v-bc6b9b12] {\n\tfont-weight: 600 !important;\n\tfont-size: 14px !important;\n\tletter-spacing: 0.01em !important;\n\tcolor: rgba(6, 38, 62, 0.74) !important;\n}\n.fade-enter-active[data-v-bc6b9b12],\n.fade-leave-active[data-v-bc6b9b12] {\n\ttransition: opacity 0.5s;\n}\n.fade-enter[data-v-bc6b9b12],\n.fade-leave-to[data-v-bc6b9b12] {\n\topacity: 0;\n}\n.missing-info-text[data-v-bc6b9b12] {\n\tcolor: rgba(117, 102, 31, 0.74) !important;\n\tfont-style: italic;\n}\n", ""]);

// exports
